import { v4 as uuidv4 } from 'uuid';

const getLabelAndValue = (string) => {
  const [label, value] = string.split('|');

  if (!value) {
    return [label.trim(), label.trim()];
  }

  return [label.trim(), value.trim()];
};

const stringToOption = (string) => {
  const [label, value] = getLabelAndValue(string);
  return { label, value };
};

export const convertTextOptionsToJson = (text = '') => {
  const linesInText = text.split('\n');
  const nonBlankLines = linesInText.filter((line) => line !== '');
  return nonBlankLines.map(stringToOption);
};

export const createOptionsListFromRawOptions = (rawOptions) =>
  convertTextOptionsToJson(rawOptions).map((newOption) => ({
    ...newOption,
    id: uuidv4(),
  }));

export const addDefaultValuesToOptionsList = (options = []) =>
  options.map((option) => ({
    ...option,
    value: options.value ? option.value : option.label,
  }));

const valueExistsInOptions = (value, options) =>
  options.some((option) => option.id === value);

export const removeDeletedSelectDefaultValues = (defaultValue, options) => {
  if (Array.isArray(defaultValue)) {
    return defaultValue.filter((value) => valueExistsInOptions(value, options));
  }

  const valueIsInOptions = valueExistsInOptions(defaultValue, options);

  if (valueIsInOptions === true) {
    return defaultValue;
  }

  return undefined;
};

const isArchivedOption = (option) => {
  const { hidden } = option;
  return hidden === true;
};

const isNotArchivedOption = (option) => !isArchivedOption(option);

const optionToSelectableOption = (option) => {
  return {
    ...option,
    value: option.id,
  };
};

const optionToSelectableOptionByValue = (option) => {
  return {
    ...option,
    value: option.value,
  };
};

const optionToDisabledOption = (option) => {
  return {
    ...option,
    value: option.id,
    disabled: true,
  };
};

export const onlyUnarchivedSelectableOptions = (_options) => {
  const options = _options ? _options : [];
  return [
    {
      label: 'Options',
      options: options
        ?.filter(isNotArchivedOption)
        .map(optionToSelectableOption),
    },
    {
      label: 'Archived Options(unavailable)',
      options: options?.filter(isArchivedOption).map(optionToDisabledOption),
    },
  ];
};

export const allSelectableOptions = (_options) => {
  const options = _options ? _options : [];
  return [
    {
      label: 'Options',
      options: options
        ?.filter(isNotArchivedOption)
        .map(optionToSelectableOption),
    },
    {
      label: 'Archived Options',
      options: options?.filter(isArchivedOption).map(optionToSelectableOption),
    },
  ];
};

export const allSelectableOptionsByValue = (_options) => {
  const options = _options ? _options : [];
  return [
    {
      label: 'Options',
      options: options
        ?.filter(isNotArchivedOption)
        .map(optionToSelectableOptionByValue),
    },
    {
      label: 'Archived Options',
      options: options
        ?.filter(isArchivedOption)
        .map(optionToSelectableOptionByValue),
    },
  ];
};

export default {
  createOptionsListFromRawOptions,
  removeDeletedSelectDefaultValues,
  addDefaultValuesToOptionsList,
  convertTextOptionsToJson,
};
